import React from "react";
import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";
import TraderProfile from "./TraderProfile";
import TraderChart from "./TraderChart";
import TraderDetailLists from "./TraderDetailLists";
import { useNavigate } from "react-router-dom";
import { goTo } from "@app/hooks/navigation";

interface IProps {
  item?: any;
  index: number;
  openModal?: any;
}

const TraderDetails = ({ item, index, openModal }: IProps) => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <View
        style={{
          width: "100%",
          alignItems: "flex-start",
          flex: "1 1 auto",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          minHeight: 0,
        }}
        onClick={() => {
          goTo(navigation, "/traderdetail");
        }}
      >
        <TraderProfile />
        <TraderChart />
        <TraderDetailLists
          title={t("roi")}
          content={"90D"}
          amount={"+64.98%"}
        />
        <TraderDetailLists
          title={t("drawdown")}
          content={"30D"}
          amount={"+59.35%"}
        />
        <TraderDetailLists
          title={t("aum")}
          content={"30D"}
          amount={"3,185,562,12"}
        />
      </View>
      <CButton
        title={t("copy")}
        onClick={() => {
          if (openModal) {
            openModal(item);
          }
        }}
        style={{
          marginTop: "12px",
          width: "100%",
          padding: "10px",
          backgroundColor: COLORS.primary,
          color: COLORS.white,
          flexShrink: 0,
        }}
      />
    </View>
  );
};

export default TraderDetails;
